import Cookies from 'js-cookie';

up.compiler('#activation-form', el => {
  if (window.mymallsMeasurementOwnsEvents) return
  if (Cookies.get('cc_tracking') === 'true' && Cookies.get('nc') && window.fbq !== undefined) {
    window.fbq('track', 'CompleteRegistration');
    Cookies.remove('nc');
  }
})
